import { __assign } from "tslib";
import React from 'react';
import { Container } from './legend-base.styles';
import Card from './card';
var LegendBase = function (_a) {
    var card = _a.card, layout = _a.layout, children = _a.children, _b = _a.spacing, spacing = _b === void 0 ? 'normal' : _b, _c = _a.fullDimension, fullDimension = _c === void 0 ? false : _c;
    var borderPosition = layout === 'vertical' ? 'top' : 'left';
    return (React.createElement(Card, __assign({ borderPosition: borderPosition, fullDimension: fullDimension }, card),
        React.createElement(Container, { layout: layout, spacing: spacing, fullDimension: fullDimension }, children)));
};
export default LegendBase;
